import { ReactElement, ReactNode } from 'react'
import { Theme } from '@mui/material/styles'
import { CollapsibleBoxInternalState } from '@ui/structure'

interface Props {
  children: ReactNode
  label: string
  startIcon?: ReactNode
  defaultExpanded?: boolean
  dataCy?: string
  headerBackgroundColor?: string | ((theme: Theme) => string)
  headerTextColor?: string | ((theme: Theme) => string)
  isEmpty?: boolean
}

const FormCollapsibleSection = ({
  children,
  label,
  startIcon,
  defaultExpanded = false,
  dataCy,
  headerBackgroundColor,
  headerTextColor,
  isEmpty = false,
}: Props): ReactElement | null => {
  if (isEmpty) return null

  return (
    <CollapsibleBoxInternalState
      variant="expander"
      label={label}
      startIcon={startIcon}
      defaultExpanded={defaultExpanded}
      dataCy={dataCy}
      headerBackgroundColor={headerBackgroundColor}
      headerTextColor={headerTextColor}
    >
      {children}
    </CollapsibleBoxInternalState>
  )
}

export default FormCollapsibleSection
